import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";
import { updateEntryMedia } from "@/util/patchMediaHelpers.js";

function patchEntryMutation(module, categoryID, path, patch) {
  const category = module.getters.category(categoryID);
  const entryIndex = category.entries.findIndex((entry) => entry.path === path);
  Object.keys(patch).forEach((key) => {
    category.entries[entryIndex][key] = patch[key];
  });
  module.commit("storeCategory", category);
}

const patchEntry = async (module, { categoryID, path, patch, opts = {} }) => {
  const api = useApiStore();
  const { getters, dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const category = getters.category(categoryID);
  const entryIndex = category.entries.findIndex((entry) => entry.path === path);
  if (entryIndex === -1) {
    throw new Error(`Entry path ${path} not found.`);
  }
  const id = path.split("/")[2];
  if (category && id) {
    if (config.updateStoreFirst) {
      patchEntryMutation(module, categoryID, path, patch);
    }
    const { status } = await dispatch("httpRequest", {
      func: api.patchEntry(id, updateEntryMedia(patch)),
      config,
    });
    if (status === 200 && !config.updateStoreFirst) {
      patchEntryMutation(module, categoryID, path, patch);
    }
  }
};

export { patchEntry, patchEntryMutation };
